import { gql } from '@apollo/client'
import fragments from 'graphql/fragments'

// Remote

export const GET_ROUNDS = gql`
  query Rounds($projectId: ID!) {
    rounds(projectId: $projectId) {
      ...Round
    }
  }
  ${fragments.round}
`

export const GET_ROUND = gql`
  query Round($roundId: ID!) {
    round(roundId: $roundId) {
      ...Round
    }
  }
  ${fragments.round}
`

// NEW API

export const _ADD_ROUND = gql`
  mutation _AddRound($projectId: ID!, $input: RoundInput!) {
    _addRound(projectId: $projectId, roundInput: $input) {
      ...Project
    }
  }
  ${fragments.project}
`

export const ADD_ROUND = gql`
  mutation AddRound($projectId: ID!, $input: RoundInput!) {
    addRound(projectId: $projectId, roundInput: $input) {
      ...Round
    }
  }
  ${fragments.round}
`

export const _ADD_ROUNDS = gql`
  mutation _AddRounds($projectId: ID!, $inputs: [RoundInput!]!) {
    _addRounds(projectId: $projectId, roundInputs: $inputs) {
      ...Project
    }
  }
  ${fragments.project}
`

export const _SAVE_ROUND = gql`
  mutation _SaveRound($roundId: ID!, $input: RoundInput!) {
    _saveRound(roundId: $roundId, roundInput: $input) {
      ...Project
    }
  }
  ${fragments.project}
`

export const _DELETE_ROUND = gql`
  mutation _DeleteRound($roundId: ID!) {
    _deleteRound(roundId: $roundId) {
      ...Project
    }
  }
  ${fragments.project}
`

const mutations = {
  addRemote: _ADD_ROUND,
  addRemotes: _ADD_ROUNDS,
  saveRemote: _SAVE_ROUND,
  deleteRemote: _DELETE_ROUND,
  saveOp: '_saveRound',
  addOp: '_addRound',
  addsOp: '_addRounds',
  deleteOp: '_deleteRound',
}

export const roundsQueries = { ...mutations, getRemote: GET_ROUNDS }
export const roundQueries = { ...mutations, getRemote: GET_ROUND }
